import { render } from "./BankCollectedDetail.vue?vue&type=template&id=447ecaca&scoped=true"
import script from "./BankCollectedDetail.vue?vue&type=script&lang=js"
export * from "./BankCollectedDetail.vue?vue&type=script&lang=js"

import "./BankCollectedDetail.vue?vue&type=style&index=0&id=447ecaca&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447ecaca"]])

export default __exports__